// extracted by mini-css-extract-plugin
module.exports = {"root":"companyInfo_root__3CdHU","error":"companyInfo_error__7illP","hidden":"companyInfo_hidden__3TyyJ","loading":"companyInfo_loading__368ke"};